import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-dropdown-arrow',
  template: `
  <ng-container *ngIf="expanded;then arrowup;else arrowdown"></ng-container>
  <ng-template #arrowdown>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="lucide lucide-chevron-down w-5 h-5 text-gray-600">
          <path d="m6 9 6 6 6-6"></path>
      </svg>
  </ng-template>

  <ng-template #arrowup>
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
          stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="lucide lucide-chevron-up w-5 h-5 text-gray-600">
          <path d="m18 15-6-6-6 6"></path>
      </svg>
  </ng-template>
  `
})
export class DropdownArrowComponent {
  @Input() expanded: boolean = false;
}
